/* istanbul ignore file */
/**
 * Confirm Popup component theme configuration.
 */

export const confirmpopup = {
  root: {
    background: '{overlay.popover.background}',
    borderColor: '{overlay.popover.border.color}',
    color: '{overlay.popover.color}',
    borderRadius: '{overlay.popover.border.radius}',
    shadow: '{overlay.popover.shadow}',
    gutter: '12px',
    arrowOffset: '20px',
  },
  content: {
    padding: '{overlay.popover.padding}',
    gap: '1rem',
  },
  icon: {
    size: '24px',
    color: '{overlay.popover.color}',
  },
  footer: {
    gap: '8px',
    padding: '0 {overlay.popover.padding} {overlay.popover.padding} {overlay.popover.padding}',
  },
};
